import Vue from 'vue';
export const EventBus = new Vue(); // 必须导出